export class Article_ProcessAPIModel {
  GetArticleProcessGrid: string = "";
  GetArticleProcessByID: string = "";
  AddUpdateArticleProcess: string = "";
  DeleteArticleProcess: string = "";
  GetProcessName: string = "";

}
